<router-outlet></router-outlet>
<div id='gridLoader' [ngClass]="{'d-none': !alertsService.isLoaderShown}">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</div>

<div [hidden]="true">
  <lib-spinner></lib-spinner>
</div>

<app-session-timeout *ngIf="showSessionTimeOutPopPup" [showModal]="showSessionTimeOutPopPup"
  [remainingTimeInMinutes]="sessionCountDownTimerInMinutes" [totallTimeInMinutes]="totallIdleTimeForUser"
  (onContinue)="initializeSession()" (onLogout)="logout()" (onSessionEnded)="onSessionEnded()">
</app-session-timeout>